export default __webpack_public_path__ + "static/media/cont11.a2fb0c0f.jpg";